import { render, staticRenderFns } from "./PrinterIcon.vue?vue&type=template&id=939e9514&scoped=true&"
import script from "./PrinterIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrinterIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939e9514",
  null
  
)

export default component.exports